/* eslint-disable eqeqeq */

// 1 => active
// 0 => not active

export const packagesStatusValues = {
  active: 1,
  notActive: 0
};

export const getPackagesStatusArr = (t) => {
  return [
    {
      id: 1,
      name: 'مفعلة',
      value: packagesStatusValues?.active
    },
    {
      id: 0,
      name: 'غير مفعلة',
      value: packagesStatusValues?.notActive
    }
  ];
};
